import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import detector from "i18next-browser-languagedetector";
import english from "./en/translation.json";
import japanese from "./ja/translation.json";

i18next
  .use(initReactI18next)
  .use(detector)
  .init({
    supportedLngs: ["ja", "en"],
    debug: true,
    fallbackLng: "en",
    interpolation: {
      // React escapes rendered text already, so i18next escaping on top of it
      // only corrupts the output — an interpolated "State / Province" reached the
      // page as "State &#x2F; Province". Same for &, quotes and apostrophes.
      escapeValue: false,
    },
    resources: {
      en: {
        translation: english,
      },
      ja: {
        translation: japanese,
      },
    },
  });
